import { connect } from 'react-redux'
import { makeStyles } from "@material-ui/styles";
import { Badge, Tooltip, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Typography, Button, Box, Paper, Modal, IconButton, TextField, FormControl, Select, InputLabel, MenuItem, CircularProgress } from "@mui/material";
import * as Action from "../../actions/adminAction"
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import TextsmsIcon from '@mui/icons-material/Textsms';
import CancelIcon from '@mui/icons-material/Cancel';
import HelpIcon from '@mui/icons-material/Help';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useLocation, useNavigate } from "react-router-dom";
import { useTrainerRoleRoute } from "../../utils/trainerRoleRoutes";
import React, { useState } from 'react';
import dayjs from "dayjs";
import Compressor from 'compressorjs';
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { BASE_URL } from '../../utils/urls';
import moment from 'moment/moment';
import docImg from '../../Assets/Image/doc.png'
import videoImg from '../../Assets/Image/Video.png'
import UTILS from "../../utils/uploadImage"
import heic2any from "heic2any";

require('../../App.css')

const TrainerData = [
  { Gram_Panchayat: 'GP_1', Assignment_Date: '12/12/2022', Shift: 'Morning', Module_Desc: 'xyz', Trainer_Name: 'abc', Trainer_Mobile: 8232988832 },
  { Gram_Panchayat: 'GP_1', Assignment_Date: '12/12/2022', Shift: 'Morning', Module_Desc: 'xyz', Trainer_Name: 'abc', Trainer_Mobile: 8232988832 },
  { Gram_Panchayat: 'GP_1', Assignment_Date: '12/12/2022', Shift: 'Morning', Module_Desc: 'xyz', Trainer_Name: 'abc', Trainer_Mobile: 8232988832 },
]

const activities = [
  'Progress', 'Snacks', 'Group Photo', 'Study Material', 'Notepad and Pen',
  'Attendance Sheet', 'Feedback Form', 'Training Outcome', 'Training Agenda',
  'Study Material Proof', 'Distribution of Ebook', 'Beneficiary Book'
]

const Session = [
  { label: "Morning", value: "morning" },
  { label: "Evening", value: "evening" },
]

const MIN_CATEGORY_IMAGES = 4;
const MAX_CATEGORY_IMAGES = 10;
const MAX_VIDEO_DURATION_SECONDS = 3 * 60; // 3 minutes

// 🆕 Visit Remark category constants
const VISIT_REMARK_CATEGORY_NAME = "Visit Remark";
const VISIT_REMARK_USER_TYPE = "regional_coordinator";

// 🆕 Attendance Sheet category constants
const ATTENDANCE_SHEET_CATEGORY_NAME = "Attendance Sheet";

const isVisitRemarkCategory = (category) =>
  category?.name?.trim().toLowerCase() === VISIT_REMARK_CATEGORY_NAME.toLowerCase();

// 🆕 Helper to get dynamic minimum images based on category
const getMinImagesForCategory = (category) => {
  const catName = category?.name?.trim().toLowerCase();
  if (catName === ATTENDANCE_SHEET_CATEGORY_NAME.toLowerCase()) {
    return 1;
  }
  return MIN_CATEGORY_IMAGES;
};

/**
 * 🆕 Get the latest Visit Remark record (if any) from uploadDocList
 */
const getVisitRemarkRecord = (uploadDocList, category) => {
  if (!category?.name || !Array.isArray(uploadDocList)) return null;
  const categoryData = uploadDocList.find(
    item => item?._id?.toLowerCase() === category.name.toLowerCase()
  );
  if (!Array.isArray(categoryData?.category) || categoryData.category.length === 0) return null;
  return categoryData.category[categoryData.category.length - 1]; // latest
};

/**
 * Image + text ko canvas pe draw karke composite File return karta hai.
 * Text image ke NEECHE (below) ek white strip me add hota hai,
 * taaki original image ka koi bhi part hide na ho.
 */
const createAnnotatedImage = (file, text) => {
  return new Promise((resolve, reject) => {
    if (!text || !text.trim()) {
      resolve(file);
      return;
    }

    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      try {
        const measureCanvas = document.createElement("canvas");
        const measureCtx = measureCanvas.getContext("2d");

        const fontSize = Math.max(18, Math.floor(img.naturalWidth / 35));
        const padding = Math.floor(fontSize * 0.6);
        const lineHeight = Math.floor(fontSize * 1.3);

        measureCtx.font = `${fontSize}px Arial, sans-serif`;

        const wrapText = (ctx, t, maxWidth) => {
          const words = t.split(" ");
          const lines = [];
          let line = "";
          for (const word of words) {
            const test = line ? line + " " + word : word;
            if (ctx.measureText(test).width > maxWidth && line) {
              lines.push(line);
              line = word;
            } else {
              line = test;
            }
          }
          if (line) lines.push(line);
          return lines;
        };

        const maxTextWidth = img.naturalWidth - padding * 2;
        const lines = wrapText(measureCtx, text.trim(), maxTextWidth);
        const stripHeight = lines.length * lineHeight + padding * 2;

        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight + stripHeight;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0);

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, img.naturalHeight, canvas.width, stripHeight);

        ctx.strokeStyle = "#e0e0e0";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(0, img.naturalHeight);
        ctx.lineTo(canvas.width, img.naturalHeight);
        ctx.stroke();

        ctx.font = `${fontSize}px Arial, sans-serif`;
        ctx.fillStyle = "#000000";
        ctx.textBaseline = "top";

        lines.forEach((l, i) => {
          ctx.fillText(l, padding, img.naturalHeight + padding + i * lineHeight);
        });

        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(url);
            if (!blob) { reject(new Error("Canvas toBlob failed")); return; }
            const annotatedFile = new File(
              [blob],
              file.name.replace(/\.\w+$/, "") + "_annotated.jpg",
              { type: "image/jpeg" }
            );
            resolve(annotatedFile);
          },
          "image/jpeg",
          0.9
        );
      } catch (err) {
        URL.revokeObjectURL(url);
        reject(err);
      }
    };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
};

/**
 * Video ka duration nikalne ke liye helper.
 * Resolves with duration in seconds, rejects if metadata can't be loaded.
 */
const getVideoDuration = (file) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;
    video.playsInline = true;

    const url = URL.createObjectURL(file);
    video.src = url;

    const cleanup = () => {
      URL.revokeObjectURL(url);
      video.removeAttribute("src");
      video.load();
    };

    video.onloadedmetadata = () => {
      const duration = video.duration;
      cleanup();
      if (!isFinite(duration) || duration <= 0) {
        reject(new Error("Could not read video duration."));
      } else {
        resolve(duration);
      }
    };

    video.onerror = () => {
      cleanup();
      reject(new Error("Could not load video metadata."));
    };
  });
};

export const Activities = ({ getAllGP, userDetails, getAllTrainingModuleData, getSingleTraining }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const roleRoute = useTrainerRoleRoute();
  const location = useLocation()
  const data = location.state
  const trimmerRef = React.useRef();
  const [gp_id, setGp_id] = React.useState(data?.grampanchayat_id)
  const [module_id, setModule_id] = React.useState(data?.trainingModule_id)
  // Array Variables
  const [typeArray, setTypeArray] = useState([])
  const [gramPanchayatArray, setGramPanchayatArray] = useState([])
  const [categoryArray, setCategoryArray] = useState([])
  const [uploadDocList, setUploadDocList] = useState([])
  const [docList, setDocList] = useState([])
  const [tableRow, setTableRow] = useState()
  const [catType, setCatType] = useState("")

  // Data Variables
  const [fromDate, setFromDate] = useState(data ? data.startDate : null)
  const [toDate, setToDate] = useState(data ? data.startDate : null)
  const [minimumDate, setMinimumDate] = useState('01/01/2000')
  const [panchayat, setPanchayat] = useState(data ? data.grampanchayatName : "")
  const [trainerData, setTrainerData] = useState([])
  const [type, setType] = useState(data ? data.trainingModuleName : "");
  const [session, setSession] = useState(data ? data.shift : "");
  const [activityData, setActivityData] = useState([]);
  const [trainingDate, setTrainingDate] = useState(data ? data.startDate : "");
  const [openModal, setOpenModal] = useState(false);
  const [showCategory, setShowCategory] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [imgUploading, setImgUploading] = useState(false);
  const [imgUploadStatus, setImgUploadStatus] = useState(false);
  const [imgUploadData, setImgUploadData] = useState();
  const [imgUploadingError, setImgUploadingError] = useState(false);
  const [imgArray, setImgArray] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState();
  const [commentModal, setCommentModal] = useState(false);
  const [showComment, setShowComment] = useState('');
  const [uploadType, setUploadType] = useState();
  const [eventData, setEventData] = useState();
  const [approveRejectCount, setApproveRejectCount] = useState();

  // Image description (remark) & Selected File for Preview
  const [imageDescription, setImageDescription] = useState("");
  const [showDescriptionError, setShowDescriptionError] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // For preview
  const [previewUrl, setPreviewUrl] = useState(null);     // For preview

  // 🆕 Visit Remark state
  const [visitRemark, setVisitRemark] = useState("");
  const [showVisitRemarkError, setShowVisitRemarkError] = useState(false);
  const [visitRemarkSubmitting, setVisitRemarkSubmitting] = useState(false);

  // Table Pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Error Variables
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [PanchayatError, setPanchayatError] = useState(false);
  const [typeError, setTypeError] = useState(false);
  const [sessionError, setSessionError] = useState(false);

  const renderCategory = categoryArray?.map((item, index) => {
    const visitRemarkCat = isVisitRemarkCategory(item);

    return (
      <div
        className={item?.isApproved ? 'statusCardApprove' : 'statusCard'}
        key={index}
        onClick={() => { fetchUploadedDocList(); setCategoryName(item); getCategoryDocType(item); }}
      >
        <div><strong>{item?.name}</strong></div>

        {/* 🆕 Visit Remark: show simple status text instead of badges */}
        {visitRemarkCat ? (
          (() => {
            const rec = getVisitRemarkRecord(uploadDocList, item);
            if (!rec) {
              return (
                <div style={{ marginTop: 10, textAlign: 'center', fontSize: 14, color: '#6b7280' }}>
                  Not submitted
                </div>
              );
            }
            const s = rec.status;
            return (
              <div
                style={{
                  marginTop: 10,
                  textAlign: 'center',
                  fontWeight: 600,
                  fontSize: 14,
                  color: s === 'approve' ? '#1e7e34' : s === 'reject' ? '#c62828' : '#8a6d00',
                }}
              >
                {s === 'approve' ? 'Approved' : s === 'reject' ? 'Rejected' : 'Pending'}
              </div>
            );
          })()
        ) : (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
            <div style={{ flex: 1 }}>
              <Tooltip title="Approved">
                <Badge color="success"
                  sx={{ "& .MuiBadge-badge": { width: 30, height: 30, fontSize: 14, borderRadius: '50%' } }}
                  style={{ margin: 15 }}
                  badgeContent={approveRejectCount?.filter(item2 => item2?._id.toLowerCase().trim() === item.name.toLowerCase().trim())[0] !== undefined ? approveRejectCount?.filter(item2 => item2?._id.toLowerCase().trim() === item.name.toLowerCase().trim())[0]?.approved.length.toString() : "0"} />
              </Tooltip>
            </div>
            <div style={{ flex: 1 }}>
              <Tooltip title="Rejected">
                <Badge color="error"
                  sx={{ "& .MuiBadge-badge": { width: 30, height: 30, fontSize: 14, borderRadius: '50%' } }}
                  style={{ margin: 15 }}
                  badgeContent={approveRejectCount?.filter(item2 => item2?._id.toLowerCase().trim() === item.name.toLowerCase().trim())[0] !== undefined ? approveRejectCount?.filter(item2 => item2?._id.toLowerCase().trim() === item.name.toLowerCase().trim())[0]?.rejected.length.toString() : "0"} />
              </Tooltip>
            </div>
            <div style={{ flex: 1 }}>
              <Tooltip title="Unprocess">
                <Badge sx={{ "& .MuiBadge-badge": { color: "white", width: 30, height: 30, fontSize: 14, borderRadius: '50%', backgroundColor: "#e9cd16" } }}
                  style={{ margin: 15 }}
                  badgeContent={approveRejectCount?.filter(item2 => item2?._id.toLowerCase().trim() === item.name.toLowerCase().trim())[0] !== undefined ? approveRejectCount?.filter(item2 => item2?._id.toLowerCase().trim() === item.name.toLowerCase().trim())[0]?.unprocessed.length.toString() : "0"} />
              </Tooltip>
            </div>
          </div>
        )}
      </div>
    );
  })

  const getTraining = async () => {
    setLoader(true)
    const result = await getSingleTraining({ trainingAssignTrainer_id: data?._id })
    if (result !== "No data found" && result !== undefined) {
      setTableRow(result[0])
      setCatType(result[0]?.categoryType)
    }
    setLoader(false)
  }

  const validateDate = () => {
    let IsformValid = true;
    if (!fromDate) { IsformValid = false; setFromDateError(true); }
    if (!toDate) { IsformValid = false; setToDateError(true); }
    if (!panchayat) { IsformValid = false; setPanchayatError(true) }
    if (!type) { IsformValid = false; setTypeError(true); }
    if (!session) { IsformValid = false; setSessionError(true); }
    return IsformValid;
  }

  React.useEffect(() => {
    async function fetchData() {
      await fetchModule();
      await getAllGramPanchayat();
      await fetchUploadedDocList();
      getTraining()
    }
    fetchData();
  }, [])

  React.useEffect(() => {
    if (tableRow) getTrainerData();
  }, [tableRow])

  const getTrainerData = async () => {
    setFromDateError(false)
    setToDateError(false)
    setPanchayatError(false)
    setTypeError(false)
    setSessionError(false)

    if (validateDate()) {
      setActivityData(activities);
      setTrainerData(TrainerData);
      await fetchUploadedDocList();
      setShowCategory(true);
    }
  }

  // STEP 1: File select + validation (image type, video duration)
  const handleChange = async (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    e.target.value = '';
    if (!selectedFiles.length) return;

    if (selectedFiles.length > 1) {
      alert('Please select only one file at a time.');
      return;
    }

    const file = selectedFiles[0];

    // -------- Image category validation --------
    if (isImageCategory(categoryName)) {
      const isImage =
        file.type.startsWith('image/') ||
        (!file.type && /\.(heic|heif)$/i.test(file.name));

      if (!isImage) {
        alert('Only image files can be uploaded to this category.');
        return;
      }

      const remainingSlots = MAX_CATEGORY_IMAGES - getCategoryDocuments(categoryName).length;
      if (remainingSlots <= 0) {
        alert(`You can upload up to ${MAX_CATEGORY_IMAGES} images to this category.`);
        return;
      }
    }

    // -------- Video category validation (3 min max) --------
    if (isVideoCategory(categoryName)) {
      if (!file.type.startsWith('video/')) {
        alert('Only video files can be uploaded to this category.');
        return;
      }
      try {
        const duration = await getVideoDuration(file);
        if (duration > MAX_VIDEO_DURATION_SECONDS) {
          const mins = Math.floor(duration / 60);
          const secs = Math.floor(duration % 60);
          alert(`Video is too long (${mins}m ${secs}s). Maximum allowed duration is 3 minutes.`);
          return;
        }
      } catch (err) {
        alert('Could not read the selected video. Please try another file.');
        return;
      }
    }

    setSelectedFile(file);
    if (file.type.startsWith('image/')) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null); // Video ya doc ke liye preview nahi
    }
  }

  // STEP 2: Confirm + upload, RESET ONLY ON SUCCESS
  const handleConfirmUpload = async () => {
    if (!selectedFile) return;

    if (isImageCategory(categoryName) && !imageDescription.trim()) {
      setShowDescriptionError(true);
      alert('Please enter the image description before uploading.');
      return;
    }

    const result = await uploadImageToS3(selectedFile, uploadType);

    if (result && result.success) {
      // Only clear the preview once it's actually uploaded
      setSelectedFile(null);
      setPreviewUrl(null);
      setImageDescription("");
      setShowDescriptionError(false);
    } else {
      // Keep the file selected so user can retry; show error
      setImgUploadingError(true);
    }
  };

  // 🆕 Visit Remark submit handler
  const handleVisitRemarkSubmit = async () => {
    if (!visitRemark.trim()) {
      setShowVisitRemarkError(true);
      alert("Please enter the visit summary before submitting.");
      return;
    }

    setVisitRemarkSubmitting(true);

    const url = BASE_URL + "/trainerevidence/inserttrainerevidence";
    const header = new Headers();
    header.append("Content-Type", "application/x-www-form-urlencoded");

    const payLoad = new URLSearchParams();
    payLoad.append("trainer_id", userDetails?._id);
    payLoad.append("trainingModule_id", tableRow.trainingModule_id);
    payLoad.append("distric_id", tableRow.distric_id);
    payLoad.append("trainingCategory_id", categoryName?.name_id);
    payLoad.append("grampanchayat_id", tableRow.grampanchayat_id);
    payLoad.append("trainingModuleName", type);
    payLoad.append("trainingCategoryName", categoryName?.name);
    payLoad.append("grampanchayatName", panchayat);
    payLoad.append("trainingDate", trainingDate);
    payLoad.append("trainerName", userDetails.firstName + " " + userDetails.lastName);
    payLoad.append("documentUrl", "https://example.com/images/digital-literacy.png");
    payLoad.append("categoryDoc", "text");
    payLoad.append("docSize", "0");
    payLoad.append("createdBy", userDetails?._id);
    payLoad.append("trainingModuleCatGp_id", categoryName?._id);
    payLoad.append("categoryType", catType);
    payLoad.append("training_id", data?._id);
    payLoad.append("visitRemark", visitRemark.trim());

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: header,
        body: payLoad,
      });

      if (res.status !== 200) {
        alert("Error While Submitting Visit Remark !");
        setImgUploadingError(true);
        return;
      }

      const resData = await res.json();
      await fetchUploadedDocList();   // refreshes uploadDocList → status chip updates
      setImgUploadData(resData);
      setImgUploadStatus(true);       // show success modal (existing)
      setShowVisitRemarkError(false);
      // 🆕 keep modal open so user sees the new "Pending" chip & saved remark
    } catch (err) {
      console.error("Visit remark submit error:", err);
      setImgUploadingError(true);
    } finally {
      setVisitRemarkSubmitting(false);
    }
  };

  const isImageCategory = (category) => {
    const types = Array.isArray(category?.type)
      ? category.type
      : category?.type
        ? [category.type]
        : [];
    return types.length > 0 && types.every(
      type => typeof type === 'string' && type.startsWith('image/')
    );
  };

  // Video category check
  const isVideoCategory = (category) => {
    const types = Array.isArray(category?.type)
      ? category.type
      : category?.type
        ? [category.type]
        : [];
    return types.length > 0 && types.every(
      type => typeof type === 'string' && type.startsWith('video/')
    );
  };

  const getCategoryDocuments = (category) => {
    if (!category?.name || !Array.isArray(uploadDocList)) return [];
    const categoryData = uploadDocList.find(
      item => item?._id?.toLowerCase() === category.name.toLowerCase()
    );
    return Array.isArray(categoryData?.category) ? categoryData.category : [];
  };

  const closeUploadModal = () => {
    // 🆕 Use dynamic minimum check here
    const minRequired = getMinImagesForCategory(categoryName);
    const hasMinimumImages =
      isImageCategory(categoryName) &&
      getCategoryDocuments(categoryName).length >= minRequired;

    if (!hasMinimumImages && !window.confirm('Are you sure you want to close the window ?')) {
      return;
    }
    setOpenModal(false);
  };

  /**
   * Returns { success: boolean }. Never throws.
   * Only calls uploadDocToAPI when S3 upload succeeded.
   */
  const uploadImageToS3 = async (event, fileType) => {
    setImgUploading(true);
    setImgUploadingError(false);

    const image = event;
    const imageName = event.name;
    const dirNameUpload =
      process.env.REACT_APP_DIR_NAME + "/" +
      tableRow?.districtName + "/" +
      tableRow?.talukaName + "/" +
      panchayat?.trim() + "/" +
      type?.trim().replace(/ /g, "_") + "/" +
      categoryName.name?.trim() + "/" +
      userDetails._id;

    fileType = image?.type?.split('/')[0];

    try {
      // ============ IMAGE ============
      if (fileType === "image") {
        const compressed = await new Promise((resolve, reject) => {
          new Compressor(image, { quality: 0.4, success: resolve, error: reject });
        });

        const annotated = await createAnnotatedImage(compressed, imageDescription);

        const timestamp = new Date().getTime();
        const safeName = imageName.replace(/\.\w+$/, "") + ".jpg";
        const newFileName = dirNameUpload + timestamp + "_" + safeName;

        const imageUrl = await UTILS.uploadImageFromBackend(
          newFileName,
          "image/jpeg",
          annotated
        );

        if (!imageUrl) {
          setImgUploadingError(true);
          return { success: false };
        }

        const apiOk = await uploadDocToAPI(imageUrl, annotated);
        if (apiOk) setImgArray(prev => [...prev, imageUrl]);
        return { success: apiOk };
      }

      // ============ VIDEO ============
      else if (fileType === "video") {
        // Send actual MIME (video/mp4 etc), not just "video"
        const realMime = image.type || "video/mp4";
        const timestamp = new Date().getTime();
        const newFileName = dirNameUpload + timestamp + imageName;

        const imageUrl = await UTILS.uploadImageFromBackend(
          newFileName,
          realMime,
          image
        );

        if (!imageUrl) {
          setImgUploadingError(true);
          return { success: false };
        }

        const apiOk = await uploadDocToAPI(imageUrl, image);
        if (apiOk) setImgArray(prev => [...prev, imageUrl]);
        return { success: apiOk };
      }

      // ============ HEIC / OTHER ============
      else {
        if (image?.type === "") {
          const imageData = await heic2any({ blob: image, toType: "image/jpeg" });
          const convertedFile = new File([imageData], "converted-image.jpg", { type: "image/jpeg" });

          const annotated = await createAnnotatedImage(convertedFile, imageDescription);

          const timestamp = new Date().getTime();
          const newFileName = dirNameUpload + timestamp + "converted-image.jpg";

          const imageUrl = await UTILS.uploadImageFromBackend(
            newFileName,
            "image/jpeg",
            annotated
          );

          if (!imageUrl) {
            setImgUploadingError(true);
            return { success: false };
          }

          const apiOk = await uploadDocToAPI(imageUrl, annotated);
          if (apiOk) setImgArray(prev => [...prev, imageUrl]);
          return { success: apiOk };
        } else {
          const timestamp = new Date().getTime();
          const newFileName = dirNameUpload + timestamp + imageName;

          const imageUrl = await UTILS.uploadImageFromBackend(
            newFileName,
            image.type || "application/octet-stream",
            image
          );

          if (!imageUrl) {
            setImgUploadingError(true);
            return { success: false };
          }

          const apiOk = await uploadDocToAPI(imageUrl, image);
          if (apiOk) setImgArray(prev => [...prev, imageUrl]);
          return { success: apiOk };
        }
      }
    } catch (err) {
      console.error("Upload error:", err);
      setImgUploadingError(true);
      return { success: false };
    } finally {
      setImgUploading(false);
    }
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const getAllGramPanchayat = async () => {
    setLoader(true)
    const allArray = [];
    const url = BASE_URL + "/trainingassigntrainer/trainingassigntrainer/grampanchayat/list";

    userDetails?.preferredDistrict_id.length > 0 && userDetails?.preferredDistrict_id.map((item, index) => {
      const payload = {
        trainer_id: userDetails?._id,
        distric_id: item,
      }
      const opt = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
      fetch(url, opt)
        .then(res => {
          if (res.status === 200) return res?.json();
          else {
            alert("Error while getting School !");
            userDetails?.preferredDistrict_id.length === index + 1 && setLoader(false);
          }
        })
        .then(data => {
          const arr = data !== "No data found" && data?.map(item => ({
            label: item?.grampanchayatName,
            value: item?.grampanchayatName,
            _id: item?.grampanchayat_id,
            taluka_id: item?.taluka_id,
            talukaName: item?.talukaName,
            distric_id: item?.distric_id,
            districtName: item?.districtName,
          }))
          data !== undefined && data !== "No data found" && allArray.push(...arr)
          setGramPanchayatArray(allArray)
          userDetails?.preferredDistrict_id.length === index + 1 && setLoader(false);
        })
        .catch(err => {
          userDetails?.preferredDistrict_id.length === index + 1 && setLoader(false);
        })
    })
  }

  const fetchModule = async () => {
    setLoader(true)
    const result = await getAllTrainingModuleData()
    const arr = result !== "No data found" && result?.map(item => ({
      label: item?.trainingModuleName,
      value: item?.trainingModuleName,
      _id: item?._id,
    }))
    setTypeArray(arr)
    setLoader(false);
  }

  const fetchCategory2 = async (list) => {
    setLoader(true);
    const url = BASE_URL + "/trainingcategory/gettrainingcategorylist/gpcat";
    const payload = {
      grampanchayat_id: gp_id,
      trainingModule_id: module_id,
      ...(userDetails?.userType?.[0] == "regional_coordinator" && { userType: userDetails?.userType?.[0] }),
    }

    await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
      .then(res => {
        if (res.status === 200) return res.json();
        else {
          alert(" Error While getting Category List ! ");
          setLoader(false);
        }
      })
      .then(data => {
        let arr = data !== undefined && data?.length > 0 ? data?.map(item => ({
          _id: item?._id,
          name_id: item?.trainingCategory_id,
          name: item?.trainingCategoryName,
          qty: item?.minDocUpload,
          maxQty: item?.maxDocUpload,
          minDocAproved: item?.minDocAproved,
          type: item?.typeOfDoc?.length > 0 ? item?.typeOfDoc : "image/*",
          moduleName: item?.trainingModuleName,
          module_id: item?.trainingModule_id,
          isApproved: item?.isApproved,
        })) : null;
        const abc = list !== undefined && list !== 'No data found' ? list?.map((item) => ({
          _id: item._id,
          approved: item.category.filter(item => item.status === 'approve'),
          unprocessed: item.category.filter(item => item.status === 'unprocess'),
          rejected: item.category.filter(item => item.status === 'reject')
        })) : undefined;
        setApproveRejectCount(abc)
        setCategoryArray(arr)
        setLoader(false);
      })
      .catch(err => { setLoader(false); })
  }

  /**
   * Returns true only if API confirmed insert succeeded.
   */
  const uploadDocToAPI = async (docURL, event) => {
    const url = BASE_URL + "/trainerevidence/inserttrainerevidence";
    const header = new Headers();
    header.append("Content-Type", "application/x-www-form-urlencoded");

    let payLoad = new URLSearchParams();

    payLoad.append("trainer_id", userDetails?._id)
    payLoad.append("trainingModule_id", tableRow.trainingModule_id)
    payLoad.append("distric_id", tableRow.distric_id)
    payLoad.append("trainingCategory_id", categoryName?.name_id)
    payLoad.append("grampanchayat_id", tableRow.grampanchayat_id)
    payLoad.append("trainingModuleName", type)
    payLoad.append("trainingCategoryName", categoryName?.name)
    payLoad.append("grampanchayatName", panchayat);
    payLoad.append("trainingDate", trainingDate);
    payLoad.append("trainerName", userDetails.firstName + " " + userDetails.lastName)
    payLoad.append("documentUrl", docURL)
    payLoad.append("categoryDoc", event?.type)
    payLoad.append("docSize", event?.size)
    payLoad.append('createdBy', userDetails?._id)
    payLoad.append('trainingModuleCatGp_id', categoryName?._id)
    payLoad.append('categoryType', catType)
    payLoad.append('training_id', data?._id)

    payLoad.append('imageRemark', imageDescription || '');

    const options = {
      method: 'POST',
      headers: header,
      body: payLoad,
    }

    try {
      const res = await fetch(url, options);
      if (res.status !== 200) {
        alert("Error While Uploading !");
        console.error("Error while Uploading to API");
        return false;
      }
      const data = await res.json();
      await fetchUploadedDocList();
      setImgUploadData(data);
      setImgUploadStatus(prev => !prev);

      return data !== "Not uploaded";
    } catch (err) {
      console.log("Error Catched", err);
      return false;
    }
  }

  const fetchUploadedDocList = async () => {
    const url = BASE_URL + "/trainerevidence/trainerevidence/grampanchayat";
    const payload = {
      grampanchayat_id: gp_id,
      trainingModule_id: module_id,
      trainingDate: trainingDate,
      training_id: data?._id
    }
    const opt = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }
    return fetch(url, opt)
      .then(res => res.json())
      .then(data => {
        data !== undefined && data !== null && setUploadDocList(data)
        fetchCategory2(data)
        return data;
      })
      .catch(err => {
        console.error('Failed to fetch uploaded documents:', err);
      });
  }

  const getCategoryDocType = (cat) => {
    setUploadType(cat?.type);
    setOpenModal(!openModal);
    setImageDescription("");
    setShowDescriptionError(false);
    setSelectedFile(null);
    setPreviewUrl(null);
    setImgUploadingError(false);
    setVisitRemark("");
    setShowVisitRemarkError(false);

    // 🆕 Prefill visit remark if it's the Visit Remark category and a record already exists
    if (isVisitRemarkCategory(cat)) {
      const existing = getVisitRemarkRecord(uploadDocList, cat);
      if (existing?.visitRemark) {
        setVisitRemark(existing.visitRemark);
      }
    }
  }

  const compareDate = (from_date) => {
    let d1 = moment(new Date()).format("DD-MM-YYYY")
    let d2 = moment(from_date).format("DD-MM-YYYY")
    let trainingDate = d2.split('-')
    let today = d1.split('-')

    if (today[2] >= trainingDate[2]) {
      if (today[2] === trainingDate[2]) {
        if (today[1] >= trainingDate[1]) {
          if (today[1] === trainingDate[1]) {
            if (today[0] >= trainingDate[0]) return true;
            else return false;
          } else return true;
        } else return false;
      } else return true;
    } else return false;
  }

  const openComment = (row) => {
    setShowComment(row);
    setCommentModal(!commentModal);
  }

  const imageCategoryCount = isImageCategory(categoryName)
    ? getCategoryDocuments(categoryName).length
    : 0;

  const isDescriptionMissing =
    isImageCategory(categoryName) && !imageDescription.trim();

  const isUploadDisabled = imgUploading ||
    !compareDate(fromDate) ||
    (isImageCategory(categoryName) && imageCategoryCount >= MAX_CATEGORY_IMAGES);

  const isVisitRemark = isVisitRemarkCategory(categoryName);

  return (
    <div className={classes.main}>
      <center>
        <Typography style={{ margin: 20, fontSize: 30, fontWeight: 600 }}>Upload Training Document</Typography>
      </center>

      {tableRow ? null :
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', flexWrap: "wrap", marginBottom: 50 }}>
          <FormControl sx={{ m: 1, marginRight: 3 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={(newValue) => {
                  setFromDate(newValue);
                  setMinimumDate((newValue?.$M + 1) + "/" + newValue?.$D + "/" + newValue?.$y)
                }}
                inputFormat={"DD/MM/YYYY"}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {fromDateError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select From Date</span> : null}
          </FormControl>
          <FormControl sx={{ m: 1, marginRight: 3 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                style={{ width: 250 }}
                label="To Date"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                inputFormat={"DD/MM/YYYY"}
                minDate={dayjs(minimumDate)}
                renderInput={(params) => <TextField {...params} />}
                className={classes.input}
              />
            </LocalizationProvider>
            {toDateError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select To Date</span> : null}
          </FormControl>
          <FormControl sx={{ m: 1, marginRight: 3 }}>
            <InputLabel id="outlined-adornment-Bank">School</InputLabel>
            <Select
              style={{ width: 250 }}
              id="outlined-adornment-month"
              label="School"
              value={panchayat}
              disabled={gramPanchayatArray ? false : true}
              onChange={(e) => { setPanchayat(e.target.value) }}
              MenuProps={{ style: { maxHeight: 400 } }}
            >
              {gramPanchayatArray && gramPanchayatArray.map((item, index) => (
                <MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>
              ))}
            </Select>
            {PanchayatError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Gram School</span> : null}
          </FormControl>
          <FormControl sx={{ m: 1, marginRight: 3 }}>
            <InputLabel id="outlined-adornment-Bank">Training Module</InputLabel>
            <Select
              style={{ width: 250 }}
              id="outlined-adornment-month"
              label="Training Module"
              value={type}
              disabled={typeArray ? false : true}
              onChange={(e) => { setType(e.target.value) }}
              MenuProps={{ style: { maxHeight: 400 } }}
            >
              {typeArray && typeArray?.map((item, index) => (
                <MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>
              ))}
            </Select>
            {typeError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Training Module</span> : null}
          </FormControl>
          <FormControl sx={{ m: 1, marginRight: 3 }}>
            <InputLabel id="outlined-adornment-Bank">Timing</InputLabel>
            <Select
              style={{ width: 250 }}
              id="outlined-adornment-month"
              label="Shift"
              value={session}
              onChange={(e) => { setSession(e.target.value) }}
              MenuProps={{ style: { maxHeight: 400 } }}
            >
              {Session && Session.map((item) => (
                <MenuItem key={item?.label} value={item?.value}>{item?.label}</MenuItem>
              ))}
            </Select>
            {sessionError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Time</span> : null}
          </FormControl>
          <Button sx={{ m: 1, marginRight: 3 }} variant='contained' disabled={tableRow ? true : false || loader ? true : false} style={{ fontSize: 14 }} onClick={() => { getTrainerData() }} >
            Get Data
          </Button>
        </div>}

      {tableRow ? <Paper sx={{ overflow: 'hidden', width: '90%' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Sr. No.</strong></TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>School</strong></TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Assignment Date</strong></TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Timing</strong></TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Module</strong></TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Action</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow >
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>1</TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{tableRow?.grampanchayatName}</TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{dayjs(tableRow?.startDate).format("DD/MM/YYYY")}</TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{tableRow?.shift ? tableRow?.shift.toUpperCase() : '-'}</TableCell>
                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{tableRow?.trainingModuleName}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  <Button variant='contained' onClick={() => navigate(roleRoute('rolloutDetails'), { state: tableRow })} style={{ margin: 5 }} >View</Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper> : null
      }

      {(showCategory || tableRow) ? <Typography style={{ margin: 20, fontSize: 30, fontWeight: 600 }}> Categories </Typography> : ''}
      <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 50, flexWrap: 'wrap', padding: '0px 10%' }}>
        {loader ? <CircularProgress color="primary" /> : null}
        {(showCategory || tableRow) ? renderCategory : ''}

        <Snackbar open={imgUploading} autoHideDuration={6000} onClose={() => { }}>
          <Alert onClose={() => { }} severity="success" sx={{ width: "100%" }}>
            Uploading...
          </Alert>
        </Snackbar>

        {/* Upload failure Snackbar */}
        <Snackbar
          open={imgUploadingError}
          autoHideDuration={6000}
          onClose={() => setImgUploadingError(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setImgUploadingError(false)} severity="error" sx={{ width: "100%" }}>
            Document upload failed. Please try again.
          </Alert>
        </Snackbar>

        <Modal
          className={classes.middlePosition}
          open={openModal}
          onClose={(e) => { e.preventDefault(); }}
        >
          <Paper className={classes.passmodal}>
            <Modal
              className={classes.middlePosition}
              open={commentModal}
              onClose={(e) => { e.preventDefault(); }}
            >
              <Paper className={classes.passmodal2}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography variant='h6' component='div'>Reject Comment</Typography>
                  <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setCommentModal(!commentModal); }}>
                    <CloseIcon />
                  </IconButton>
                </div>
                <div style={{ marginTop: '5%' }}>{showComment}</div>
                <center>
                  <Button sx={{ m: 1, marginRight: 3 }} variant='contained' style={{ fontSize: 14 }} onClick={() => { setCommentModal(!commentModal); }} >
                    OK
                  </Button>
                </center>
              </Paper>
            </Modal>

            <Modal
              className={classes.middlePosition}
              open={imgUploadStatus}
              onClose={(e) => { e.preventDefault(); }}
            >
              <Paper className={classes.passmodal2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                  <Stack direction="column"></Stack>
                  <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setImgUploadStatus(!imgUploadStatus); }}>
                    <CloseIcon />
                  </IconButton>
                </Stack>
                {imgUploadData === "Not uploaded" ? <div>Error Document is not Uploaded !</div> : <div>Document Uploaded Successfully !</div>}
                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                  <Button sx={{ m: 1, marginRight: 3 }} variant='contained' style={{ fontSize: 14 }} onClick={() => { setImgUploadStatus(!imgUploadStatus); }} >
                    OK
                  </Button>
                </div>
              </Paper>
            </Modal>

            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <Stack direction="column"></Stack>
              <IconButton aria-label="delete" onClick={e => { e.preventDefault(); closeUploadModal(); }}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontSize: 20, fontWeight: 600, padding: '0px 20px' }}>Category</div>
                <div style={{ fontSize: 20, fontWeight: 600, padding: '0px 20px' }}>Module</div>
                <div style={{ fontSize: 20, fontWeight: 600, padding: '0px 20px' }}>School</div>
                <div style={{ fontSize: 20, fontWeight: 600, padding: '0px 20px' }}>Date</div>
                {!isVisitRemark && (
                  <div style={{ fontSize: 20, fontWeight: 600, padding: '0px 20px' }}>Upload Format</div>
                )}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ fontSize: 20, fontWeight: 400, padding: '0px 20px' }}>{categoryName.name}</div>
                <div style={{ fontSize: 20, fontWeight: 400, padding: '0px 20px' }}>{type}</div>
                <div style={{ fontSize: 20, fontWeight: 400, padding: '0px 20px' }}>{panchayat}</div>
                <div style={{ fontSize: 20, fontWeight: 400, padding: '0px 20px' }}>{dayjs(fromDate).format('DD-MM-YYYY')}</div>
                {!isVisitRemark && (
                  <div style={{ fontSize: 20, fontWeight: 600, padding: '0px 20px' }}>
                    {(Array.isArray(uploadType) ? uploadType : uploadType ? [uploadType] : []).map((item, index) => {
                      if (item === 'image/*') return <span key={index}>{"• IMAGE "}</span>;
                      else if (item === 'video/*') return <span key={index}>{"• VIDEO "}</span>;
                      else return <span key={index}>{"• EXCEL • PDF • WORD "}</span>;
                    })}
                  </div>
                )}
              </div>
            </div>

            {isVisitRemark ? (() => {
              const existingVisitRemark = getVisitRemarkRecord(uploadDocList, categoryName);
              const visitRemarkStatus = existingVisitRemark?.status; // 'unprocess' | 'approve' | 'reject'

              return (
                <Box sx={{ mt: 3 }}>
                  {/* 🆕 Status indicator */}
                  {existingVisitRemark && (
                    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
                      <Box
                        sx={{
                          px: 2,
                          py: 0.6,
                          borderRadius: 2,
                          fontWeight: 600,
                          fontSize: 14,
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 1,
                          backgroundColor:
                            visitRemarkStatus === 'approve'
                              ? '#e6f4ea'
                              : visitRemarkStatus === 'reject'
                                ? '#fdecea'
                                : '#fff4cc',
                          color:
                            visitRemarkStatus === 'approve'
                              ? '#1e7e34'
                              : visitRemarkStatus === 'reject'
                                ? '#c62828'
                                : '#8a6d00',
                          border: `1px solid ${visitRemarkStatus === 'approve'
                            ? '#a8d5b5'
                            : visitRemarkStatus === 'reject'
                              ? '#f5c2c0'
                              : '#f0d97a'
                            }`,
                        }}
                      >
                        {visitRemarkStatus === 'approve' && <VerifiedIcon style={{ fontSize: 18 }} />}
                        {visitRemarkStatus === 'reject' && <CancelIcon style={{ fontSize: 18 }} />}
                        {visitRemarkStatus === 'unprocess' && <HelpIcon style={{ fontSize: 18 }} />}
                        {visitRemarkStatus === 'approve'
                          ? 'Approved'
                          : visitRemarkStatus === 'reject'
                            ? 'Rejected'
                            : 'Pending'}
                      </Box>
                    </Box>
                  )}

                  <TextField
                    label="Visit Summary *"
                    placeholder="Enter your visit summary/remark..."
                    value={visitRemark}
                    onChange={(e) => {
                      setVisitRemark(e.target.value);
                      if (e.target.value.trim()) setShowVisitRemarkError(false);
                    }}
                    onBlur={() => setShowVisitRemarkError(!visitRemark.trim())}
                    fullWidth
                    multiline
                    rows={5}
                    required
                    error={showVisitRemarkError}
                    helperText={showVisitRemarkError ? "Visit summary is required." : ""}
                    disabled={visitRemarkStatus === 'approve'} // 🆕 Disable input if approved
                  />

                  {/* 🆕 Hide buttons if status is approved */}
                  {visitRemarkStatus !== 'approve' && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          setVisitRemark("");
                          setShowVisitRemarkError(false);
                          setOpenModal(false);
                        }}
                        disabled={visitRemarkSubmitting}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleVisitRemarkSubmit}
                        disabled={visitRemarkSubmitting || !visitRemark.trim()}
                        sx={{ minWidth: 150 }}
                      >
                        {visitRemarkSubmitting ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : existingVisitRemark ? (
                          'Update'
                        ) : (
                          'Submit'
                        )}
                      </Button>
                    </Box>
                  )}
                </Box>
              );
            })() : (
              <>
                {isImageCategory(categoryName) && (
                  <Typography variant="body2" sx={{ mt: 2, textAlign: 'right' }}>
                    Images uploaded: {imageCategoryCount}/{MAX_CATEGORY_IMAGES}
                    {' '}(minimum {getMinImagesForCategory(categoryName)})
                  </Typography>
                )}

                {/* Video hint */}
                {isVideoCategory(categoryName) && (
                  <Typography variant="body2" sx={{ mt: 2, textAlign: 'right', color: '#555' }}>
                    Maximum video duration: 3 minutes
                  </Typography>
                )}

                {!selectedFile ? (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button
                      component="label"
                      variant="contained"
                      disabled={isUploadDisabled}
                      sx={{
                        minHeight: 44,
                        px: 2.5,
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'none',
                        backgroundColor: isUploadDisabled ? '#e5e7eb' : '#1976d2',
                        color: isUploadDisabled ? '#6b7280' : '#ffffff',
                        border: `1px solid ${isUploadDisabled ? '#d1d5db' : '#1976d2'}`,
                        boxShadow: isUploadDisabled ? 'none' : '0 4px 12px rgba(25, 118, 210, 0.25)',
                        '&:hover': isUploadDisabled ? {} : {
                          backgroundColor: '#1565c0',
                          boxShadow: '0 6px 16px rgba(25, 118, 210, 0.32)',
                        },
                        '&.Mui-disabled': {
                          backgroundColor: '#e5e7eb',
                          color: '#6b7280',
                          borderColor: '#d1d5db',
                          boxShadow: 'none',
                        },
                      }}
                    >
                      Select Document to Upload
                      <input
                        accept={uploadType}
                        disabled={isUploadDisabled}
                        id="icon-button-file"
                        type="file"
                        hidden
                        onChange={(e) => {
                          if (compareDate(fromDate)) handleChange(e)
                          else alert("Cannot upload Documents For Upcomming Training Session");
                        }}
                      />
                    </Button>
                  </Box>
                ) : (
                  <Box sx={{ mt: 3, p: 2, border: '1px dashed #1976d2', borderRadius: 2, backgroundColor: '#f8fbff' }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>Selected File Preview</Typography>

                    {previewUrl && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <img
                          src={previewUrl}
                          alt="preview"
                          style={{ maxWidth: '100%', maxHeight: 250, borderRadius: 8, objectFit: 'contain', border: '1px solid #ddd' }}
                        />
                      </Box>
                    )}

                    {!previewUrl && (
                      <Typography variant="body2" sx={{ mb: 2, textAlign: 'center', color: '#555' }}>
                        Selected: {selectedFile.name}
                      </Typography>
                    )}

                    {isImageCategory(categoryName) && (
                      <TextField
                        label="Image Description *"
                        placeholder="What does this image depict?"
                        value={imageDescription}
                        onChange={(e) => {
                          setImageDescription(e.target.value);
                          if (e.target.value.trim()) setShowDescriptionError(false);
                        }}
                        onBlur={() => setShowDescriptionError(!imageDescription.trim())}
                        fullWidth
                        multiline
                        rows={2}
                        required
                        error={showDescriptionError}
                        helperText={showDescriptionError ? "Description is required to upload." : "This text will be added below the image."}
                        sx={{ mt: 1, mb: 2 }}
                      />
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          setSelectedFile(null);
                          setPreviewUrl(null);
                          setImageDescription("");
                          setShowDescriptionError(false);
                        }}
                        disabled={imgUploading}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleConfirmUpload}
                        disabled={imgUploading || (isImageCategory(categoryName) && isDescriptionMissing)}
                        sx={{ minWidth: 150 }}
                      >
                        {imgUploading ? <CircularProgress size={24} color="inherit" /> : 'Confirm & Upload'}
                      </Button>
                    </Box>
                  </Box>
                )}
              </>
            )}

            {/* Hide documents gallery for Visit Remark */}
            {!isVisitRemark && (
              <>
                <h3>Documents</h3>
                {imgUploading ? <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress color="primary" />
                </div> : null}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', flexWrap: 'wrap' }}>
                  {
                    uploadDocList !== "No data found" && uploadDocList !== undefined && uploadDocList.length > 0
                      ? uploadDocList?.filter(item => item?._id?.toLowerCase() === categoryName?.name?.toLowerCase())[0]?.category?.map((item, index) =>
                      // Do not render broken/blank tiles
                      (!item?.documentUrl ? null :
                        <div key={index} className='imgContainer'>
                          {item.status === "reject" ? <div className='deleteIcon' >
                            <IconButton size="large" aria-label="delete" onClick={e => { openComment(item.approveRejectComment) }}>
                              <TextsmsIcon color="error" />
                            </IconButton>
                          </div> : null}

                          {item.status === "approve" ? <div className='statusIcon'>
                            <IconButton size="large" aria-label="status">
                              <VerifiedIcon style={{ fontSize: '40px' }} color="success" />
                            </IconButton>
                          </div> : null}

                          {item.status === "reject" ? <div className='statusIcon'>
                            <IconButton size="large" aria-label="status">
                              <CancelIcon style={{ fontSize: '40px' }} color="error" />
                            </IconButton>
                          </div> : null}

                          {item.status === "unprocess" ? <div className='statusIcon'>
                            <IconButton size="large" aria-label="status">
                              <HelpIcon style={{ fontSize: '40px' }} sx={{ color: '#ffd435' }} />
                            </IconButton>
                          </div> : null}

                          {item.status === "unprocess" ? <div className='textUnderProcess'>Under Process</div> : null}
                          {item.status === "approve" ? <div className='textApproved'>Approved</div> : null}
                          {item.status === "reject" ? <div className='textRejected'>Rejected</div> : null}

                          {item?.categoryDoc?.split('/')[0] === "image" ? <div className='img'>
                            <a target="_blank" href={item.documentUrl} rel="noreferrer">
                              <img src={item.documentUrl} style={{ height: '100%', width: '100%' }} alt="doc" />
                            </a>
                          </div> : item?.categoryDoc?.split('/')[0] === "video" ? <div className='img'>
                            <a target="_blank" href={item.documentUrl} rel="noreferrer">
                              <img src={videoImg} style={{ height: '100%', width: '100%' }} alt="video" />
                            </a>
                          </div> : <div className='img'>
                            <a target="_blank" href={item.documentUrl} rel="noreferrer">
                              <img src={docImg} style={{ height: '100%', width: '100%' }} alt="doc" />
                            </a>
                          </div>}
                        </div>
                      )
                      )
                      : <center><div>No Data Found</div></center>
                  }
                </div>
              </>
            )}
          </Paper>
        </Modal>
      </div>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 1,
          flexWrap: 'wrap',
          width: '100%',
          maxWidth: 1200,
          px: { xs: 2, sm: 3 },
          mb: 2,
          boxSizing: 'border-box',
        }}
      >
        <Button variant="contained" onClick={() => navigate(-1)}
          sx={{ flex: { xs: 1, sm: '0 0 auto' }, minWidth: { xs: 0, sm: 112 } }}>
          Back
        </Button>
        <Button variant="contained" onClick={() => fetchUploadedDocList()}
          sx={{ flex: { xs: 1, sm: '0 0 auto' }, minWidth: { xs: 0, sm: 112 } }}>
          Reload
        </Button>
      </Box>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  redStar: { color: 'red', fontSize: 22, fontWeight: 600, listStyleType: "none" },
  main: { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: 'column', marginTop: 30 },
  card: { width: '1200px', borderRadius: '20px !important', margin: '20px', padding: '20px' },
  passmodal2: { width: '50%', background: 'white', margin: '20px', padding: '20px' },
  passmodal: { width: '90%', height: '70%', background: 'white', margin: '20px', padding: '20px', overflow: 'scroll' },
  profilemodal: { width: '1400px', background: 'white', borderRadius: '20px !important', margin: '20px', padding: '20px' },
  middlePosition: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' },
  input: { width: '100%', background: 'white', marginTop: '20px', padding: '5px 15px' },
}));

const mapStateToProps = (state) => {
  return { userDetails: state.auth.userDetails }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllGP: () => dispatch(Action.getAllgrampanchayatdata()),
    getAllTrainingModuleData: () => dispatch(Action.getAllTrainingModuleData()),
    getSingleTraining: (data) => dispatch(Action.getSingleTraining(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Activities);